// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyCrtLkQGIItOC2DULiQkvg22Hp0WotYWpU",
    authDomain: "sweetdopamine-web.firebaseapp.com",
    projectId: "sweetdopamine-web",
    storageBucket: "sweetdopamine-web.firebasestorage.app",
    messagingSenderId: "1045982589105",
    appId: "1:1045982589105:web:554e1e13e50f8120de7290",
    measurementId: "G-ZYZ9S927KT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);